// extracted by mini-css-extract-plugin
export default {"device":"ParallelLabVideo-module--device--39b0a","modalContent":"ParallelLabVideo-module--modalContent--47a54","close":"ParallelLabVideo-module--close--83a8b"};